<template>
    <div id="moduleAppList">
         <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
           <el-input size="medium" class="search-input search-input--right" placeholder="角色名称"
                      v-model="rolename" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>

        <div >
            <el-table
                :height="windowHeight - 205"
                :data="dataList" border
                style="width: 100%"
            >
                <el-table-column
                    label="名称"
                    prop="name"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="是否可选"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ ['', '可选', '不可选', '不可选但默认'][scope.row.isChoose] }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="角色常量"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.constantId }}
                    </template>

                </el-table-column>
                <el-table-column
                    label="描述"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.description }}
                    </template>

                </el-table-column>


                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="jumpToPage('schoolRoleEdit', {id: scope.row.id, schoolId})">编辑</el-button>
                        <el-button type="text" @click="jumpToPage('schoolRoleUserList', {id: scope.row.id, schoolId})">角色用户</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';

    import {
        querySchoolRoleList
    } from '@/api/schoolManage';

    export default {
        name: 'schoolRoleList',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                rolename: '',
                dataList: [],
                multipleSelection:[],
            }
        },
        components: {BackTool},
        created() {
            this.querySchoolRoleListFunc()

        },
        mixins: [windowResize, baseMixin],
        methods: {
            getList() {
                this.pagination.pageNo = 1;
                this.querySchoolRoleListFunc();
            },
            sizeChangeHandler() {
                this.querySchoolRoleListFunc();
            },
            currentChangeHandler() {
                this.querySchoolRoleListFunc();
            },
            querySchoolRoleListFunc() {
                querySchoolRoleList({
                    rolename: this.rolename,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.dataList = data.roles;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>

<style lang="scss">
    #moduleAppList {
        padding: 12px;
          .top {
    padding-bottom: 10px;
  }

        a {
            color: #409EFF;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolRole/schoolRoleList.vue